import LinearBuyingAssignments from "./LinearBuyingAssignments";

export default LinearBuyingAssignments;
